import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { AuthError } from "@supabase/supabase-js";
import { ChangePasswordForm } from "@/components/auth/ChangePasswordForm";
import { useAuth } from "@/contexts/AuthContext";

const AuthPage = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const [isLoading, setIsLoading] = useState(true);
  const [shouldChangePassword, setShouldChangePassword] = useState(false);
  const { session, refreshSession } = useAuth();

  useEffect(() => {
    // Only check session state, don't create additional listeners
    if (session?.user) {
      if (session.user.user_metadata?.should_change_password) {
        setShouldChangePassword(true);
      } else {
        navigate("/");
      }
    }
    setIsLoading(false);
  }, [navigate, session]);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (shouldChangePassword) {
    return (
      <div className="min-h-screen bg-background">
        <div className="container mx-auto py-6 max-w-md">
          <h1 className="text-2xl font-bold mb-6">Change Your Password</h1>
          <p className="mb-4 text-muted-foreground">
            Please change your password before continuing.
          </p>
          <ChangePasswordForm onSuccess={() => {
            setShouldChangePassword(false);
            navigate("/");
          }} />
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background">
      <div className="w-full max-w-md p-8 space-y-4 border rounded-lg shadow-lg bg-card">
        <img 
          src="/lovable-uploads/4eccf673-365a-4879-9e88-1b83b9e95d63.png" 
          alt="Logo" 
          className="h-12 mx-auto mb-6"
        />
        <Auth
          supabaseClient={supabase}
          appearance={{
            theme: ThemeSupa,
            variables: {
              default: {
                colors: {
                  brand: '#FF5F00',
                  brandAccent: '#e65600',
                },
              },
            },
          }}
          providers={[]}
          theme="light"
          showLinks={false}
        />
      </div>
    </div>
  );
};

export default AuthPage;